import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    type: "light", // @Feature: Dark mode "dark"
    primary: {
      light: "#80b4ff",
      main: "#4285f4",
      dark: "#0059c1",
      contrastText: "#fff"
    },
    secondary: {
      light: "#6f81a3",
      main: "#425574",
      dark: "#162c48",
      contrastText: "#fff"
    },
    error: {
      main: "#EA4335"
    },
    text: {
      primary: "rgba(0, 0, 0, 0.95)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)"
    },
    custom: {
      blue: {
        primary: {
          light: "#80b4ff",
          main: "#4285f4",
          dark: "#0059c1",
          contrastText: "#fff"
        },
        secondary: {
          light: "#6f81a3",
          main: "#425574",
          dark: "#162c48",
          contrastText: "#fff"
        }
      },
      green: {
        primary: {
          light: "#6bda81",
          main: "#34A853",
          dark: "#007827",
          contrastText: "#fff"
        },
        secondary: {
          light: "#405044",
          main: "#19281d",
          dark: "#000000",
          contrastText: "#fff"
        }
      },
      red: {
        primary: {
          light: "#ff7860",
          main: "#EA4335",
          dark: "#b0000c",
          contrastText: "#fff"
        },
        secondary: {
          light: "#9a6762",
          main: "#6a3c38",
          dark: "#3d1412",
          contrastText: "#fff"
        }
      },
      yellow: {
        primary: {
          light: "#ffee4f",
          main: "#FBBC05",
          dark: "#c38c00",
          contrastText: "#fff"
        },
        secondary: {
          light: "#ac9453",
          main: "#7b6628",
          dark: "#4c3c00",
          contrastText: "#000"
        }
      }
    }
  },
  overrides: {
    MuiInput: {
      underline: {
        "&:after": {
          borderBottomColor: "#4285f4"
        }
      }
    },
    MuiFormLabel: {
      focused: {
        color: "#4285f4"
      }
    },
    MuiCircularProgress: {
      colorPrimary: "#4285f4",
      colorSecondary: "#0059c1"
    },
    MuiLinearProgress: {
      colorPrimary: "#4285f4",
      colorSecondary: "#0059c1"
    }
  }
});



// WEBPACK FOOTER //
// ./src/theme.js